import { render, staticRenderFns } from "./BlockFormPopup.vue?vue&type=template&id=116977d4&scoped=true&"
import script from "./BlockFormPopup.vue?vue&type=script&lang=js&"
export * from "./BlockFormPopup.vue?vue&type=script&lang=js&"
import style0 from "./BlockFormPopup.vue?vue&type=style&index=0&id=116977d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116977d4",
  null
  
)

export default component.exports